import { isNil } from 'lodash-es'
import React, { ChangeEvent, ReactElement } from 'react'

import { Box, GhostSelect, InputWrapper, Typo } from '../atoms'

export interface SelectInputProps<T> {
  'aria-labelledby'?: string
  name?: string
  placeholder?: string
  value: T | undefined
  values: { value: T | undefined; text: string }[]
  onChange: (value: T | undefined) => void
  loading?: boolean
}

export const SelectInput: <T extends string | number = string>(
  props: SelectInputProps<T>,
) => ReactElement = ({
  'aria-labelledby': ariaLabelledBy,
  name,
  placeholder,
  value,
  values,
  onChange,
  loading,
}) => {
  const options = values.map(({ value, text }) => (
    <Typo as='option' key={value} value={value} color='body'>
      {text}
    </Typo>
  ))

  const onChangeCallback = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault()
    const offset = placeholder ? 1 : 0
    const item = values[e.target.selectedIndex - offset]
    onChange(item?.value)
  }

  const selectedValue = values.find((it) => it.value === value)?.value

  return (
    <InputWrapper width={1}>
      <Box width={1}>
        <Typo
          fontFamily='input'
          color={placeholder && isNil(selectedValue) ? 'placeholder' : 'inherit'}
        >
          <GhostSelect
            aria-labelledby={ariaLabelledBy}
            name={name}
            onChange={onChangeCallback}
            value={selectedValue ?? placeholder}
            loading={loading}
          >
            {placeholder && (
              <Typo as='option' color='placeholder' value={placeholder} disabled hidden>
                {placeholder}
              </Typo>
            )}
            {options}
          </GhostSelect>
        </Typo>
      </Box>
    </InputWrapper>
  )
}
